var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLastSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16665_191852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0578 26.6796L21.094 19.7158C22.9917 17.3948 23.9248 14.4332 23.7001 11.4436C23.4755 8.454 22.1104 5.66509 19.8872 3.65374C17.6639 1.64239 14.7527 0.562507 11.7556 0.637444C8.75846 0.712381 5.9048 1.93641 3.78486 4.05635C1.66493 6.17629 0.440897 9.02994 0.365959 12.027C0.291022 15.0242 1.37091 17.9354 3.38226 20.1586C5.3936 22.3819 8.18252 23.747 11.1721 23.9716C14.1618 24.1962 17.1233 23.2632 19.4443 21.3655L26.4081 28.3293C26.6282 28.5418 26.9229 28.6594 27.2288 28.6568C27.5347 28.6541 27.8273 28.5314 28.0436 28.3151C28.2599 28.0988 28.3826 27.8062 28.3853 27.5003C28.3879 27.1944 28.2703 26.8997 28.0578 26.6796ZM12.0663 21.6711C10.2204 21.6711 8.41585 21.1237 6.88099 20.0982C5.34613 19.0726 4.14986 17.615 3.44344 15.9095C2.73702 14.2041 2.55219 12.3274 2.91232 10.517C3.27245 8.70647 4.16136 7.04343 5.46665 5.73814C6.77194 4.43285 8.43498 3.54393 10.2455 3.1838C12.056 2.82367 13.9326 3.00851 15.638 3.71492C17.3435 4.42134 18.8011 5.61762 19.8267 7.15248C20.8523 8.68734 21.3997 10.4918 21.3997 12.3378C21.3969 14.8123 20.4126 17.1847 18.6629 18.9344C16.9132 20.6841 14.5408 21.6684 12.0663 21.6711Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16665_191852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.399902 0.669922)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLastSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/last-search.986a3a22.svg";
export { ForwardRef as ReactComponent };